import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OpAdminCheckoutService } from '../../services/op-admin-checkout.service';
import { OpAdminOrdersService } from '../../services/op-admin-orders.service';

@Component({
  selector: 'app-order-edit-shipping-address',
  templateUrl: './order-edit-shipping-address.component.html',
  styleUrls: ['./order-edit-shipping-address.component.css']
})
export class OrderEditShippingAddressComponent implements OnInit {

  addressUpdateDialog: FormGroup;
  @Input() title: string;
  @Input() message: string;
  @Input() shippingAddressData: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  orderData: any;

  updateAddressForm: FormGroup;
  codeList: any = [];
  tosterConfig = {
    positionClass: "toast-top-center",
  };


  constructor(private activeModal: NgbActiveModal,
    private checkoutSrv: OpAdminCheckoutService,
    private ordersrv: OpAdminOrdersService,
    private toastr: ToastrService,) { }

  id: any;
  shipping_firstname: any;
  shipping_lastname: any;
  shipping_address: any;
  shipping_city: any;
  shipping_country: any;
  shipping_postcode: any

  ngOnInit() {
    this.orderData = this.shippingAddressData.orderData;
    this.getCountryList();
    this.buildCheckOutForm();
  }

  buildCheckOutForm() {
    this.updateAddressForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      shipping_firstname: new FormControl(null, Validators.required),
      shipping_lastname: new FormControl(null, Validators.required),
      shipping_address: new FormControl(null, Validators.required),
      shipping_city: new FormControl(null, Validators.required),
      shipping_postcode: new FormControl(null, Validators.required),
      shipping_country: new FormControl(null, Validators.required),
    });
    this.patchCheckOutForm(this.shippingAddressData);
  }


  fetchDetailsFromOrder() {
    this.updateAddressForm.patchValue({
      id: this.orderData.orderId,
      email: this.orderData.email,
      shipping_firstname: this.orderData.first_name,
      shipping_lastname: this.orderData.last_name,
      shipping_address: this.orderData.address,
      shipping_city: this.orderData.city,
      shipping_postcode: this.orderData.postcode,
      shipping_country: this.orderData.country,
    });
  }


  patchCheckOutForm(addressData) {
    this.updateAddressForm.patchValue({
      id: addressData.id,
      email: addressData.email,
      shipping_firstname: addressData.firstname,
      shipping_lastname: addressData.lastname,
      shipping_address: addressData.address,
      shipping_city: addressData.city,
      shipping_postcode: addressData.postCode,
      shipping_country: addressData.country,
    });
  }

  getCountryList() {
    this.checkoutSrv.getCodeList().subscribe((res: any) => {
      this.codeList = res.data;
    });
  }

  shippingAddressUpdate(formValues) {
    if (this.shippingAddressData.isConvertToPostal == true) {
      this.ordersrv.convertToPostalOrder(formValues).subscribe(
        (res: any) => {
          if (res.statusCode == 200) {
            this.activeModal.close(true)
          }
        });
    } else {
      this.ordersrv.updateShippingAddress(formValues).subscribe(
        (res: any) => {
          if (res.statusCode == 200) {
            this.activeModal.close(true)
          }
        });
    }


  }

  public decline() {
    this.activeModal.close(false);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

}
